import React, { useState } from 'react';
import './Menu.css';
import OpenHours from '../components/OpenHours';
import OrderNowButton from '../components/OrderNowButton';
import menuFood from '../assets/menus/menu_food.jpg';
import menuDrinks from '../assets/menus/menu_drinks.jpg';
import menuCocktails from '../assets/menus/menu_cocktails.jpg';
import menuKidsDrinksApps from '../assets/menus/menu_kids_drinks_apps.jpg';
import menuSpecials from '../assets/menus/menu_specials.PNG';
import menuHappyHour from '../assets/menus/menu_happy_hour.jpg';

const Menu = () => {
  const [activeTab, setActiveTab] = useState('food');

  const menuTabs = [
    { id: 'food', label: 'Food Menu', image: menuFood },
    { id: 'drinks', label: 'Drinks', image: menuDrinks },
    { id: 'cocktails', label: 'Cocktails', image: menuCocktails },
    { id: 'kids-drinks-apps', label: 'Kids, Drinks & Apps', image: menuKidsDrinksApps },
    { id: 'specials', label: 'Specials', image: menuSpecials },
    { id: 'happy-hour', label: 'Happy Hour', image: menuHappyHour },
  ];

  return (
    <div className="menu-page">
      <div className="menu-container">
        <OpenHours />
        
        <h1 className="menu-title">Our Menu</h1>
        <div className="order-now-section">
          <OrderNowButton theme="dark" />
        </div>
        
        <div className="menu-tabs">
          {menuTabs.map((tab) => (
            <button
              key={tab.id}
              className={`menu-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="menu-content">
          {menuTabs.map((tab) => (
            <div
              key={tab.id}
              className={`menu-panel ${activeTab === tab.id ? 'active' : ''}`}
            >
              <img 
                src={tab.image} 
                alt={`${tab.label} Menu`} 
                className="menu-image"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu; 